import Form from "./Form";

// import { useAuth } from "../../auth/AuthContext";
import UserDataSkeleton from "../../../components/skeletons/UserDataSkeleton";
import { useGetCurrentUserQuery } from "../../user/userApiSlice";

const UserData = () => {
	const { data: user, error, isLoading } = useGetCurrentUserQuery(undefined);

	if (isLoading) {
		return <UserDataSkeleton />;
	}

	return <Form user={user} />;
};

export default UserData;
